const sectionClass = '.infographic-cards-container';
const mobileSpacingBetweenCards = 30;

function getElementOffsetFromTop(element) {
  const section = element.parentElement;
  const sectionRect = section.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  const offsetFromTop = elementRect.top - sectionRect.top;
  return offsetFromTop;
}

function getElementOffsetFromBottom(element) {
  const section = element.closest((`${sectionClass}`));
  const sectionRect = section.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  const offsetFromBottom = sectionRect.bottom - elementRect.bottom;
  return offsetFromBottom;
}

function getElementCenterFromTop(element) {
  const offsetFromTop = getElementOffsetFromTop(element);
  return offsetFromTop + (element.clientHeight / 2) - 1;
}

function getElementCenterFromBottom(element) {
  const offsetFromBottom = getElementOffsetFromBottom(element);
  return offsetFromBottom + (element.clientHeight / 2) + 2;
}

function setPseudoElementBottom(pseudo, value) {
  const styleSheet = document.styleSheets[0];
  const selector = `${sectionClass}::${pseudo}`;
  const rule = window.innerWidth > 959 ? `bottom: ${value}px;` : `bottom: ${value + mobileSpacingBetweenCards}px;`;

  styleSheet.insertRule(`${selector} { ${rule} }`, styleSheet.cssRules.length);
}

function setPseudoElementTop(pseudo, value) {
  const styleSheet = document.styleSheets[0];
  const selector = `${sectionClass}::${pseudo}`;
  const rule = `top: ${value}px;`;

  styleSheet.insertRule(`${selector} { ${rule} }`, styleSheet.cssRules.length);
}

const initInfographicCards = () => {
  const section = document.querySelector(`${sectionClass}`);

  if(!section) return

  const firstChild = section.firstElementChild;
  const elementDesktop = document.querySelector('.centered-arrow-position-element');
  const elementMobile = document.querySelector('.centered-arrow-position-element-mobile');
  const elementCenterFromBottom = window.innerWidth > 959 ? getElementCenterFromBottom(elementDesktop) : getElementCenterFromBottom(elementMobile);

  const firstChildCenterFromTop = getElementCenterFromTop(firstChild);

  // Set the  `top` and `bottom` values for the `::before` and `::after` pseudo-elements
  setPseudoElementTop('before', firstChildCenterFromTop);
  setPseudoElementTop('after', firstChildCenterFromTop);

  setPseudoElementBottom('before', elementCenterFromBottom);
  setPseudoElementBottom('after', elementCenterFromBottom);
}

export default initInfographicCards;